export default "__VITE_ASSET__Cf2vz81E__"